export default __webpack_public_path__ + "static/media/loader.3800d229.svg";